import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { Buffer } from "buffer";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./App.module.scss";
import "./index.css";

Sentry.init({
  dsn: "https://44371d0a71d952136ce36e5fc2b631a1@o4507616705511424.ingest.us.sentry.io/4508143285895168",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 1.0,
  release: import.meta.env.VITE_APP_VERSION,
  enabled:
    import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ||
    import.meta.env.VITE_SENTRY_ENVIRONMENT === "development",
});

window.Buffer = Buffer;
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <TonConnectUIProvider
    manifestUrl={`${import.meta.env.VITE_PUBLIC_URL}/tonconnect-manifest.json`}
  >
    <BrowserRouter>
      <Sentry.ErrorBoundary
        fallback={
          <p style={{ color: "black" }}>
            An error has occurred. Please reload the page.
          </p>
        }
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </TonConnectUIProvider>
);
